document.addEventListener('click',event=>{const b=event.target.closest('button');if(!b)return;if(b.id==='menu-toggle'){const n=document.querySelector('.head nav');const open=n.classList.toggle('open');b.setAttribute('aria-expanded',String(open));}if(b.id==='search-toggle'){const f=document.querySelector('#search-form');f.hidden=!f.hidden;if(!f.hidden)f.querySelector('input[type=search]').focus();}if(b.dataset.image){const img=document.querySelector('#main-product-image');img.src=b.dataset.image;img.removeAttribute('srcset');}});
document.addEventListener('change',event=>{if(event.target.id==='variant-select'){const url=new URL(location.href);url.searchParams.set('variant',event.target.value);location.assign(url.href);}});
function openGuide(){const id=decodeURIComponent(location.hash.slice(1));const el=document.getElementById(id);if(el?.matches('details.sa-guide'))el.open=true;}
try{openGuide();}catch{}window.addEventListener('hashchange',()=>{try{openGuide();}catch{}});


/* Manual and automatically advancing retailer carousel, with seamless duplication. */
(() => {
  const viewport = document.querySelector('.retail-band .partner-window');
  const track = viewport?.querySelector('.partner-track');
  const previous = document.getElementById('carousel-prev');
  const next = document.getElementById('carousel-next');
  if (!viewport || !track || !previous || !next) return;

  const logos = Array.from(track.children);
  const originalCount = logos.length / 2;
  if (!Number.isInteger(originalCount) || originalCount < 2) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let cycle = 0;
  let step = 0;
  let position = 0;
  let drag = null;
  let tween = null;
  let suppressClick = false;
  let lastFrame = performance.now();

  function measure() {
    cycle = logos[originalCount].offsetLeft - logos[0].offsetLeft;
    step = logos[1].offsetLeft - logos[0].offsetLeft;
    if (cycle > 0) setPosition(position);
  }

  function setPosition(value) {
    if (!cycle) return;
    position = ((value % cycle) + cycle) % cycle;
    track.style.transform = 'translate3d(' + (-position) + 'px, 0, 0)';
  }

  function move(direction) {
    tween = null;
    if (reducedMotion.matches) {
      setPosition(position + direction * step);
      return;
    }
    tween = { from: position, distance: direction * step, start: performance.now(), duration: 280 };
  }

  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  viewport.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
  });
  viewport.addEventListener('dragstart', event => event.preventDefault());
  viewport.addEventListener('pointerdown', event => {
    if (event.button !== 0) return;
    suppressClick = false;
    tween = null;
    drag = { id: event.pointerId, startX: event.clientX, startPosition: position, active: false };
  });
  viewport.addEventListener('pointermove', event => {
    if (!drag || event.pointerId !== drag.id) return;
    const distance = event.clientX - drag.startX;
    if (!drag.active && Math.abs(distance) < 7) return;
    if (!drag.active) {
      drag.active = true;
      tween = null;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    }
    setPosition(drag.startPosition - distance);
    if (event.cancelable) event.preventDefault();
  });
  function finishDrag(event) {
    if (!drag || drag.id !== event.pointerId) return;
    if (drag.active) {
      suppressClick = true;
      viewport.classList.remove('is-dragging');
      if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
    }
    drag = null;
  }
  viewport.addEventListener('pointerup', finishDrag);
  viewport.addEventListener('pointercancel', finishDrag);
  viewport.addEventListener('click', event => {
    if (!suppressClick) return;
    event.preventDefault();
    event.stopPropagation();
    suppressClick = false;
  }, true);

  measure();
  window.addEventListener('resize', measure);

  function frame(now) {
    const elapsed = Math.min(Math.max(now - lastFrame, 0), 90);
    lastFrame = now;
    if (tween) {
      const progress = Math.min((now - tween.start) / tween.duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setPosition(tween.from + tween.distance * eased);
      if (progress >= 1) tween = null;
    } else if (
      !drag &&
      !reducedMotion.matches &&
      !document.hidden
    ) {
      setPosition(position + (cycle / 40000) * elapsed);
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();

(() => {
  function initializeCartons(root) {
    root.querySelectorAll('input[data-carton-units]:not([data-carton-ready])').forEach(quantityInput => {
      const units = Number(quantityInput.dataset.cartonUnits);
      const minimum = Number(quantityInput.dataset.cartonMin) || 1;
      const originalQuantity = Number(quantityInput.value);
      const form = quantityInput.form;
      if (!Number.isSafeInteger(units) || units <= 1 || !form || !quantityInput.name) return;
      const input = quantityInput.cloneNode(false);
      input.removeAttribute('name');
      input.removeAttribute('data-carton-units');
      input.id = quantityInput.id + '-cartons';
      input.dataset.cartonReady = 'true';
      input.value = String(originalQuantity / units);
      input.defaultValue = input.value;
      input.min = quantityInput.min === '0' ? '0' : String(minimum);
      input.step = '1';
      if (input.max !== '') input.max = String(Math.floor(Number(input.max) / units));
      quantityInput.before(input);
      quantityInput.type = 'hidden';
      quantityInput.dataset.cartonReady = 'true';
      const label = document.getElementById(quantityInput.dataset.cartonLabel);
      if (label) {
        label.htmlFor = input.id;
        label.textContent = quantityInput.dataset.cartonLabelText;
      }
      const synchronize = () => {
        const cartons = input.valueAsNumber;
        const zeroAllowed = input.min === '0' && cartons === 0;
        const quantity = cartons * units;
        const valid = Number.isSafeInteger(cartons) && Number.isSafeInteger(quantity) &&
          (zeroAllowed || cartons >= minimum) &&
          (input.max === '' || cartons <= Number(input.max));
        input.setCustomValidity(valid ? '' : quantityInput.dataset.cartonError);
        quantityInput.disabled = !valid;
        if (valid) quantityInput.value = String(quantity);
        return valid;
      };
      input.addEventListener('input', synchronize);
      input.addEventListener('change', synchronize);
      if (form.id === 'sa-product-form' && document.getElementById('carton-add-error')) {
        let submitting = false;
        form.addEventListener('submit', async event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (submitting) return;
          if (!synchronize() || !form.checkValidity()) {
            form.reportValidity();
            return;
          }
          const errorBox = document.getElementById('carton-add-error');
          const button = form.querySelector('button[type="submit"]');
          const defaultError = errorBox.dataset.defaultError;
          errorBox.hidden = true;
          submitting = true;
          if (button) button.disabled = true;
          form.setAttribute('aria-busy', 'true');
          try {
            const body = new FormData(form);
            body.set('quantity', quantityInput.value);
            const url = new URL(form.action, location.href);
            url.pathname = url.pathname.replace(/\/add\/?$/, '/add.js');
            const response = await fetch(url.href, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
              body
            });
            const result = await response.json();
            if (!response.ok || Number(result.status) >= 400) {
              const message = typeof result.description === 'string' ? result.description :
                typeof result.message === 'string' ? result.message : defaultError;
              throw new Error(message);
            }
            location.assign(errorBox.dataset.cartUrl);
          } catch (error) {
            errorBox.querySelector('[data-carton-error-message]').textContent =
              error instanceof TypeError ? defaultError : error.message || defaultError;
            errorBox.hidden = false;
          } finally {
            submitting = false;
            if (button) button.disabled = false;
            form.removeAttribute('aria-busy');
          }
        }, true);
      } else {
        form.addEventListener('submit', event => {
          if (!synchronize()) {
            event.preventDefault();
            input.reportValidity();
          }
        }, true);
      }
      synchronize();
    });
  }
  initializeCartons(document);
  document.addEventListener('shopify:section:load', event => initializeCartons(event.target));
})();
